module.exports = __webpack_public_path__ + "36476859ead8e3121721057603fd01ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/poster/chapter-two-intro-poster.jpg
// module id = 294
// module chunks = 0